import { fetcher } from "helpers/fetcher";

import {
  TUpdateJobListingFacilitiesReq,
  TUpdateJobListingFacilitiesRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateJobListingFacilities = async (
  payload: TUpdateJobListingFacilitiesReq
) => {
  return await fetcher<
    TUpdateJobListingFacilitiesRes,
    TUpdateJobListingFacilitiesReq["data"]
  >(ENDPOINT.CORPORATION.UPDATE_JOB_LISTING_FACILITY, {
    data: payload.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.UPDATE_JOB_LISTING_FACILITY.version,
      [API_HEADER.CORP_ID]: payload.idCorp,
    },
  });
};

export const mutationUpdateJobListingFacilities = async (
  payload: TUpdateJobListingFacilitiesReq
) => {
  return (await updateJobListingFacilities(payload)).data;
};

mutationUpdateJobListingFacilities._key = (
  payload: TUpdateJobListingFacilitiesReq
) => [ENDPOINT.CORPORATION.UPDATE_JOB_LISTING_FACILITY.url, payload];
